import { render, staticRenderFns } from "./OpenReference.vue?vue&type=template&id=6a836b0a&scoped=true&"
import script from "./OpenReference.vue?vue&type=script&lang=js&"
export * from "./OpenReference.vue?vue&type=script&lang=js&"
import style0 from "./OpenReference.vue?vue&type=style&index=0&id=6a836b0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a836b0a",
  null
  
)

export default component.exports